export default {
  white: '#FFFFFF',
  whiteSmoke: '#F3F6F8',
  transWhite: 'hsla(0, 0%, 100%, 0.96)',
  transWhite50: 'hsla(0, 0%, 100%, 0.7)',
  transWhite10: 'hsla(0, 0%, 100%, 0.1)',
  grayXXXS: 'hsl(0, 0%, 98%)',
  grayXXS: 'hsl(0, 0%, 95%)',
  grayXS: 'hsl(0, 0%, 90%)',
  graySXS: 'hsl(0, 0%, 85%)',
  grayS: 'hsl(0, 0%, 80%)',
  grayM: 'hsl(0, 0%, 70%)',
  grayML: 'hsl(0, 0%, 65%)',
  grayL: 'hsl(0, 0%, 50%)',
  grayXL: 'hsl(0, 0%, 25%)',
  grayXXL: 'hsl(0, 0%, 10%)',
  black: 'hsl(0, 0%, 0%)',
  transBlack: 'hsla(0, 0%, 0%, 0.2)',
  fauxblack: '#031016',
  red: '#FF112F',
  emphasis: '#16A29A', // buildrz new green
  darkEmphasis: '#12807A',
  hover: '#7FCBB4',
  cyanCornFlowerBlue: '#1997CC',
  complementary: '#F16553', // red | buildrzRed
  green: '#00CC77',
  darkgreen: '#00B368',
  orange: '#FFC200',
  lightOrange: '#FFCE47',
  yellow: '#F9EF2F', // maximum yellow
  redXS: '#EDAA62',
  redS: '#FA8D5F',
  redL: '#E04B3A',
  redXL: '#B1060D',
  fluorescentOrange: '#FFC300',
  middleYellow: '#FFED00',
  yellowOrange: '#FFAD30',

  // status colors
  // tuscan: '#E6D3A3', // 00 lead -> color.green
  maximumBlue: '#42ACC2', // 01 1er contact
  sunglow: '#FFCB39', // 02 1er rendez-vous
  brightYellow: '#FAA91A', // 03 2e rendez-vous
  carminePink: '#F04D50', // 04 Offre émise
  androidGreen: '#8AC640', // 05 Offre acceptée
  pearlyPurple: '#B25BA3', // 06 Promesse et CE
  vividCerulean: '#09A6E0', // 07 Permis déposé
  toolbox: '#7174B7', // 08 Permis purgé
  deer: '#BE7C4E', // 09 En chantier
  // 10 grayXL used for Livré instead of this
  darkVanilla: '#D6BEA8', // 11 Lead écarté
  electricIndigo: '#6208E0',

  // view.js
  alabaster: '#F4F4E4', // protected buildings
  queenBlue: '#467594',

  // model3d.js -- plu geom
  lime: '#00FC10',
  darkSlateBlue: '#444499',
  dukeBlue: '#000099',
  harlequinGreen: '#3EC300',
  graniteGray: '#666666',

  // base_rules.js
  lightGraniteGray: '#666666',
  darkGraniteGray: '#606060',
  pureYellow: '#FFFF00',
  magenta: '#FF00E1',

  // rules_grammar.js
  vividSkyBlue: '#00E3FC',
  royalBlue: '#2D1FC4',
  heliotrope: '#EB70F4',
  pureRed: '#FF0000',
  lasalleGreen: '#017C20',
  spartanCrimson: '#A00B0B',

  // visualization.js
  sangria: '#930505',
  limeColorWheel: '#BDFF00',

  // tile.js
  blackOlive: '#404040',
  laurelGreen: '#A6B99D',
  quickSilver: '#A5A4AA',

  // parcel.js
  hotMagenta: '#FF00D0',
  pureBlue: '#0000FF',
  pureGreen: '#00FF00',

  // price map
  navajoWhite: '#FEE5A5',
  topaz: '#FEC36C',
  deepSaffron: '#FE9929',
  sinopia: '#C3500A',
  traditionalBrown: '#993404',

  // available plu zone
  tuftsBlue: '#3F88C5',

  // borders
  borderFront: '#00FF00',
  borderBack: '#000000',
  borderSide: '#0000FF',
  borderZone: '#FFFF00',

  // parking colors
  paleCyan: '#75D1F6',
  paleMagentaPink: '#FF99C9',
  littleBoyBlue: '#6A7FDB',
  lavender: '#A682FF',
  exteriorParkingSpace: '#020262',
  asphaltColor: '#A3A3B4',

  //buildings
  projectBuilding: '#16A29A',
  nonProjectBuilding: '#EBEBEB',
  nonEditableBuilding: '#EBEBEB',
  architecturalSequence: '#FBC169',

  mutabilityColor: '#C20026',
  roseRedXS: 'rgba(220,92,128,0.1)',
  roseRedS: 'rgba(220,92,128,0.2)',
  roseRedL: 'rgba(220,92,128,0.3)',
  roseRedXL: 'rgba(220,92,128,0.5)',

  // map colors
  babyPowder: '#FCFCFC',
  persianGreen: '#0CA69E',
  mintCream: '#F0F5F2',
  mintAlabster: '#D5F5E2',
  vividTangelo: '#F37823',
  antiFlashWhite: '#F2F2F2',
  isabelline: '#EDEDED',
  middleBlueGreen: '#7DD4CF',
  silverSand: '#C4C4C4',
  mayaBlue: '#75D0F6',

  //dxf export
  trees: '#669900',
  limits: '#906813',
  projectParcel: '#88ff88',
  otherParcels: '#b35900',
  realBuildings: '#0000ff',
  userBuildings: '#ff0000',
};
